import axios from 'axios'
import { Toast } from 'vant'
import store from '@/store'
import { getToken,removeToken } from '@/utils/auth'

const baseUrl = () => {
  const { promiseBaseUrl } = document.querySelector('html').dataset
  if (promiseBaseUrl) {
    return `${promiseBaseUrl}`
  }
  return process.env.VUE_APP_API_BASE_URL
}
// create an axios instance
const service = axios.create({
  //baseURL: process.env.VUE_APP_API_BASE_URL, // url = base url + request url
  baseURL:baseUrl(),
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['token'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(response => {

  
  if (response.status == 200) {
    const res = response.data
  
    const codeState = res.code
  
    switch (codeState) {
      case 200:
        return Promise.resolve(res.data || "")
       // return Promise.resolve(res)
        break
			
	 case 404:
	    // console.log(res)
		if(res.msg === '用户未注册'){
			return Promise.resolve(res)
		}
		break;
 
      case 401:
        removeToken()
        router.push({
          path: '/login'
        })
        break
      default:
        Toast.fail(res.msg)
        return Promise.reject(res)
    }
  } 
  else {
    Toast.fail('服务器请求失败')
    return Promise.reject('服务器请求失败')
  }
  
})

export default service
